import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Card, Form, Input, Button, Space, message } from 'antd';
import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import { createMusicStyle } from '../../graphql/mutation';

const CreateMusicStyle = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [create, { loading }] = useMutation(createMusicStyle, {
    onCompleted: () => {
      message.success('Music style created');
      navigate('/music-styles');
    },
    onError: (error) => {
      message.error(`Failed to create: ${error.message}`);
    }
  });

  const handleSubmit = (values) => {
    create({
      variables: {
        name: values.name,
        icon: values.icon,
      }
    });
  };

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/music-styles')}>
              Back
            </Button>
            <span>Create Music Style</span>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ maxWidth: 500 }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter a name' }]}
          >
            <Input placeholder="Style name (e.g., Rock, Jazz, Pop)" />
          </Form.Item>

          <Form.Item
            label="Icon (Emoji)"
            name="icon"
            rules={[{ required: true, message: 'Please enter an icon' }]}
          >
            <Input placeholder="🎵" style={{ fontSize: 24 }} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={loading}>
              Create Style
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateMusicStyle;
